// extracted by mini-css-extract-plugin
module.exports = {"city-select-icon":"CitySelect_city-select-icon__GV_cr"};